/// <amd-module name="Wit/Search/InstantSearchProviders/DayZeroMessageProvider" />
import { IReadonlyObservableArray } from "VSS/Core/Observable";
import { announce } from "VSS/Core/Util/Accessibility";
import { Services, IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { IMenuItem, MenuItemType } from "VSSUI/Menu";
import { BaseInstantSearchProvider } from "InstantSearch/Shared/InstantSearchProviders/BaseInstantSearchProvider";
import { IMenuServiceContext, IInstantSearchMenuService } from "InstantSearch/Shared/Types";
import * as Resources from "Wit/Search/Resources";

/**
 * Service for displaying day zero message.
 */
export class DayZeroMessageProvider extends BaseInstantSearchProvider<undefined> implements IInstantSearchMenuService<IMenuServiceContext> {
    protected _contributionId = "ms.vss-work-web.dayzero-message-menu-provider";
    private _isWorkitemAvailable = true;
    private _isBoardsAvailable: boolean;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._initContribution(this._contributionId);
        this._isBoardsAvailable = isFeatureFlagEnabled(pageContext, "TeamFoundationRecentActivityService.DisplayUserProjectActivities", false);
    }

    protected _getMenuItems(menuId: string,
        context: IMenuServiceContext,
        invokeProvider: boolean,
        searchText: string
    ): IReadonlyObservableArray<IMenuItem> | null {
        if (!invokeProvider || searchText) {
            if (this._menuItems.length > 0) {
                this._menuItems.splice(0, this._menuItems.length);
            }
            this._isWorkitemAvailable = true;
            this._isBoardsAvailable = true;
        }
        return this._menuItems;
    }

    public updateWorkItemState(isWorkitemAvailable: boolean): void {
        this._isWorkitemAvailable = isWorkitemAvailable;
        this._updateDayZeroMessage();
    }

    public updateBoardState(isBoardsAvailable: boolean): void {
        this._isBoardsAvailable = isBoardsAvailable;
        this._updateDayZeroMessage();
    }

    private _updateDayZeroMessage(): void {
        if (this._menuItems.length > 0) {
            this._menuItems.splice(0, this._menuItems.length);
        }

        if (!this._isBoardsAvailable && !this._isWorkitemAvailable) {
            this._menuItems.push({
                id: "",
                itemType: MenuItemType.Normal,
                className: "suggestion-message",
                groupKey: this._groupKey,
                rank: this._rank,
                text: Resources.DayZeroMessage
            });
            announce(Resources.DayZeroMessage);
        }
    }
}

Services.add(
    "dayzero-message-provider-service",
    { serviceFactory: DayZeroMessageProvider }
);
